import { render, staticRenderFns } from "./Bands.vue?vue&type=template&id=4c022c94&scoped=true&"
import script from "./Bands.vue?vue&type=script&lang=js&"
export * from "./Bands.vue?vue&type=script&lang=js&"
import style0 from "./Bands.vue?vue&type=style&index=0&id=4c022c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c022c94",
  null
  
)

export default component.exports